import { FC } from 'react';

import Wrapper from './Wrapper';

export { Wrapper as AlertWrapper };

export type AlertTextPosition = 'left' | 'center' | 'right';

export type AlertVariant = 'info' | 'dark' | 'light' | 'danger' | 'success' | 'warning';

export type AlertProps = {
  variant: AlertVariant;
  position: AlertTextPosition;
  isIcon?: boolean;
  className?: string;
};

const Alert: FC<AlertProps> = ({ children, ...wrapperProps }) => <Wrapper {...wrapperProps}>{children}</Wrapper>;

export default Alert;
